import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Loader from '@/components/common/Loader';
import { LazyDialog } from '@/modules/Dialogs';
import lazyWithRetry from '@/utils/lazyWithRetry';

const PledgeIntegrationDialogContent = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "pledge-integration-dialog" */
    '@/modules/PledgeIntegration/components/PledgeIntegrationDialogContent'
  ),
);

export default function PledgeIntegrationDialog({
  campaignId,
  editMode,
  extCampaignId,
  goal,
  onClose,
  shareMode,
  title,
  trimmedCampaignId,
  ...dialogProps
}) {
  const fallback = <Loader isCentered />;
  const [error, setError] = React.useState(null);

  return (
    <React.Suspense fallback={fallback}>
      <LazyDialog
        scroll="paper"
        fullWidth
        maxWidth="lg"
        classes={{
          paper: classNames(
            'w-full',
            error ? 'h-2/3 md:h-1/4 md:w-1/2' : 'h-full md:h-5/6 md:w-5/6',
          ),
        }}
        onClose={onClose}
        {...dialogProps}
      >
        <PledgeIntegrationDialogContent
          campaignId={campaignId}
          extCampaignId={extCampaignId}
          editMode={editMode}
          goal={goal}
          onClose={onClose}
          onApiErrorUpdate={setError}
          shareMode={shareMode}
          title={title}
          trimmedCampaignId={trimmedCampaignId}
        />
      </LazyDialog>
    </React.Suspense>
  );
}

PledgeIntegrationDialog.propTypes = {
  campaignId: PropTypes.string,
  extCampaignId: PropTypes.string,
  editMode: PropTypes.bool,
  goal: PropTypes.number,
  onClose: PropTypes.func,
  shareMode: PropTypes.bool,
  title: PropTypes.string,
  trimmedCampaignId: PropTypes.string,
};

PledgeIntegrationDialog.defaultProps = {
  campaignId: null,
  extCampaignId: null,
  editMode: false,
  goal: null,
  onClose: () => {},
  shareMode: false,
  title: null,
  trimmedCampaignId: null,
};
